var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.508484 5.0015C3.52583 2.80396 8.5135 0 11.5 0C14.4865 0 19.4742 2.80396 22.4915 5.0015C23.1805 5.5033 23.1625 6.47638 22.4788 6.98469C19.5202 9.18428 15.2409 12 11.5 12C7.75906 12 3.47984 9.18428 0.52119 6.98469C-0.162545 6.47638 -0.180509 5.5033 0.508484 5.0015ZM15.111 6C15.111 7.84095 13.4943 9.33333 11.5 9.33333C9.50576 9.33333 7.88908 7.84095 7.88908 6C7.88908 4.15905 9.50576 2.66667 11.5 2.66667C13.4943 2.66667 15.111 4.15905 15.111 6ZM13.6641 6C13.6641 7.10457 12.6941 8 11.4975 8C10.3009 8 9.33092 7.10457 9.33092 6C9.33092 4.89543 10.3009 4 11.4975 4C12.6941 4 13.6641 4.89543 13.6641 6Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.89fcfc34.svg";
export { ForwardRef as ReactComponent };